/* Mold Labs — interaktivní 3D náhled produktu (STL) v galerii.
   • three.js se stahuje až ve chvíli, kdy je náhled potřeba (dynamický import z CDN)
   • vlastní parser STL — binární i ASCII, formát se pozná z obsahu (ne z přípony),
     takže funguje i soubor přejmenovaný na .stl.txt (Shopify Files někdy .stl odmítá)
   • vlastní ovládání: tažení = otáčení, kolečko/pinch = zoom, Shift/pravé tlačítko = posun
   • všechny styly se nastavují PŘÍMO na elementech (živý obchod strhává styly z HTML) */
(function () {
  /* three.js načítáme klasickým <script> (UMD build) — Shopify přepisuje dynamický import() na require() */
  var THREE_URL = 'https://cdn.jsdelivr.net/npm/three@0.159.0/build/three.min.js';
  var THREE_FALLBACK = 'https://unpkg.com/three@0.159.0/build/three.min.js';
  var threeP = null;
  function loadScript(url) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = url; s.async = true; s.crossOrigin = 'anonymous';
      s.onload = function () { window.THREE ? res(window.THREE) : rej(new Error('three not global')); };
      s.onerror = function () { rej(new Error('three script failed: ' + url)); };
      document.head.appendChild(s);
    });
  }
  function three() {
    if (threeP) return threeP;
    if (window.THREE) { threeP = Promise.resolve(window.THREE); return threeP; }
    threeP = loadScript(THREE_URL).catch(function () { return loadScript(THREE_FALLBACK); });
    return threeP;
  }

  function css(el, o) { for (var k in o) el.style[k] = o[k]; return el; }
  function el(tag, styles, parent, text) {
    var n = document.createElement(tag);
    if (styles) css(n, styles);
    if (text != null) n.textContent = text;
    if (parent) parent.appendChild(n);
    return n;
  }
  function hasWebGL() {
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
    } catch (e) { return false; }
  }
  function mix(hex, other, amt) {
    var a = parseInt(hex.slice(1), 16), b = parseInt(other.slice(1), 16);
    var r = Math.round((a >> 16 & 255) * (1 - amt) + (b >> 16 & 255) * amt);
    var g = Math.round((a >> 8 & 255) * (1 - amt) + (b >> 8 & 255) * amt);
    var bl = Math.round((a & 255) * (1 - amt) + (b & 255) * amt);
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + bl).toString(16).slice(1);
  }

  function preview(buf) {
    var b = new Uint8Array(buf, 0, Math.min(96, buf.byteLength)), s = '', hex = '';
    for (var i = 0; i < b.length; i++) {
      s += (b[i] >= 32 && b[i] < 127) ? String.fromCharCode(b[i]) : '.';
      if (i < 16) hex += ('0' + b[i].toString(16)).slice(-2) + ' ';
    }
    return JSON.stringify(s) + ' | hex: ' + hex;
  }

  /* ---------- STL ---------- */
  function isBinary(buf) {
    if (buf.byteLength < 84) return false;
    var dv = new DataView(buf);
    var faces = dv.getUint32(80, true);
    // spolehlivý test: sedí počet trojúhelníků na velikost souboru? (některé exporty mají přebytečné bajty na konci)
    var expect = 84 + faces * 50;
    if (faces > 0 && buf.byteLength >= expect && buf.byteLength - expect < 512) return true;
    // jinak: obsahuje text "facet normal"? → ASCII. Pozor, i binární STL začínají často slovem "solid".
    var head = '';
    var bytes = new Uint8Array(buf, 0, Math.min(2048, buf.byteLength));
    for (var i = 0; i < bytes.length; i++) head += String.fromCharCode(bytes[i]);
    return head.toLowerCase().indexOf('facet normal') === -1;
  }
  function parseBinary(buf, THREE) {
    var dv = new DataView(buf), faces = dv.getUint32(80, true);
    if (!faces || 84 + faces * 50 > buf.byteLength) throw new Error('bad binary STL header');
    var pos = new Float32Array(faces * 9), nor = new Float32Array(faces * 9);
    for (var f = 0; f < faces; f++) {
      var o = 84 + f * 50;
      var nx = dv.getFloat32(o, true), ny = dv.getFloat32(o + 4, true), nz = dv.getFloat32(o + 8, true);
      for (var v = 0; v < 3; v++) {
        var vo = o + 12 + v * 12, i = f * 9 + v * 3;
        pos[i] = dv.getFloat32(vo, true); pos[i + 1] = dv.getFloat32(vo + 4, true); pos[i + 2] = dv.getFloat32(vo + 8, true);
        nor[i] = nx; nor[i + 1] = ny; nor[i + 2] = nz;
      }
    }
    var g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    g.setAttribute('normal', new THREE.BufferAttribute(nor, 3));
    return g;
  }
  function parseASCII(text, THREE) {
    var pos = [], nor = [];
    var re = /facet\s+normal\s+([-+eE0-9.]+)\s+([-+eE0-9.]+)\s+([-+eE0-9.]+)[\s\S]*?outer\s+loop([\s\S]*?)endloop/g;
    var vre = /vertex\s+([-+eE0-9.]+)\s+([-+eE0-9.]+)\s+([-+eE0-9.]+)/g;
    var m;
    while ((m = re.exec(text)) !== null) {
      var nx = +m[1], ny = +m[2], nz = +m[3], vm, count = 0;
      vre.lastIndex = 0;
      while ((vm = vre.exec(m[4])) !== null && count < 3) {
        pos.push(+vm[1], +vm[2], +vm[3]); nor.push(nx, ny, nz); count++;
      }
    }
    var g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    g.setAttribute('normal', new THREE.Float32BufferAttribute(nor, 3));
    return g;
  }
  /* Vadné STL často obsahují trojúhelníky s nulovou plochou nebo NaN — ty dělají paprsčité pruhy. */
  function dropDegenerate(geo, THREE) {
    var p = geo.getAttribute('position'), nr = geo.getAttribute('normal');
    var tri = p.count / 3, keepP = [], keepN = [], removed = 0;
    for (var t = 0; t < tri; t++) {
      var i = t * 3;
      var ax = p.getX(i), ay = p.getY(i), az = p.getZ(i);
      var bx = p.getX(i + 1), by = p.getY(i + 1), bz = p.getZ(i + 1);
      var cx = p.getX(i + 2), cy = p.getY(i + 2), cz = p.getZ(i + 2);
      if (!isFinite(ax + ay + az + bx + by + bz + cx + cy + cz)) { removed++; continue; }
      var ux = bx - ax, uy = by - ay, uz = bz - az, vx = cx - ax, vy = cy - ay, vz = cz - az;
      var nx = uy * vz - uz * vy, ny = uz * vx - ux * vz, nz = ux * vy - uy * vx;
      if (Math.hypot(nx, ny, nz) < 1e-9) { removed++; continue; }
      for (var k = 0; k < 3; k++) {
        keepP.push(p.getX(i + k), p.getY(i + k), p.getZ(i + k));
        keepN.push(nr.getX(i + k), nr.getY(i + k), nr.getZ(i + k));
      }
    }
    if (!removed) return geo;
    console.log('[ml-3d] odstraněno vadných trojúhelníků:', removed);
    var g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.Float32BufferAttribute(keepP, 3));
    g.setAttribute('normal', new THREE.Float32BufferAttribute(keepN, 3));
    return g;
  }

  /* STL nemá hladké normály — dopočítáme je, ostré hrany (nad prahem) zůstanou ostré. */
  function smooth(geo, THREE, deg) {
    var pos = geo.getAttribute('position'), nor = geo.getAttribute('normal');
    var n = pos.count, map = Object.create(null), key, i;
    geo.computeBoundingBox();
    var size = geo.boundingBox.getSize(new THREE.Vector3()).length() || 1;
    var q = size / 20000;
    var keys = new Array(n);
    for (i = 0; i < n; i++) {
      key = Math.round(pos.getX(i) / q) + '|' + Math.round(pos.getY(i) / q) + '|' + Math.round(pos.getZ(i) / q);
      keys[i] = key;
      var acc = map[key] || (map[key] = [0, 0, 0, 0]);
      acc[0] += nor.getX(i); acc[1] += nor.getY(i); acc[2] += nor.getZ(i); acc[3]++;
    }
    var lim = Math.cos(deg * Math.PI / 180);
    for (i = 0; i < n; i++) {
      var a = map[keys[i]];
      var l = Math.hypot(a[0], a[1], a[2]);
      var fx = nor.getX(i), fy = nor.getY(i), fz = nor.getZ(i);
      if (l < 1e-6) continue;            // protilehlé plochy se vyrušily → nechat původní
      if (a[3] > 24) continue;           // příliš mnoho ploch v jednom bodě → vada modelu
      var ax = a[0] / l, ay = a[1] / l, az = a[2] / l;
      if (ax * fx + ay * fy + az * fz > lim) nor.setXYZ(i, ax, ay, az);
    }
    for (i = 0; i < n; i++) {
      var lx = nor.getX(i), ly = nor.getY(i), lz = nor.getZ(i);
      var ll = Math.hypot(lx, ly, lz);
      if (ll > 1e-9) nor.setXYZ(i, lx / ll, ly / ll, lz / ll);
      else nor.setXYZ(i, 0, 1, 0);
    }
    nor.needsUpdate = true;
    return geo;
  }

  /* ---------- rozbalení chráněného formátu .mlm ---------- */
  function b64buf(s) {
    var bin = atob(s.replace(/[\s"']/g, ''));
    var u = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i);
    return u.buffer;
  }

  function unpack(buf) {
    var u = new Uint8Array(buf);
    // textová varianta "MLM1:<base64>" (kvůli Shopify Files, které bere jen .txt)
    if (u.length > 5 && u[0] === 77 && u[1] === 76 && u[2] === 77 && u[3] === 49 && u[4] === 58) {
      try { return unpack(b64buf(new TextDecoder().decode(u.subarray(5)))); } catch (e) { return buf; }
    }
    if (u.length < 9 || u[0] !== 77 || u[1] !== 76 || u[2] !== 77 || u[3] !== 49) return buf; // 'MLM1'
    var seed = ((u[4] | (u[5] << 8) | (u[6] << 16) | (u[7] << 24)) >>> 0);
    var s = (seed ^ 0x4D4C3344) >>> 0; if (!s) s = 0x9E3779B9;
    var out = new Uint8Array(u.length - 8);
    for (var i = 0; i < out.length; i++) {
      s ^= (s << 13); s >>>= 0; s ^= (s >>> 17); s ^= (s << 5); s >>>= 0;
      out[i] = u[i + 8] ^ (s & 255);
    }
    return out.buffer;
  }

  /* ---------- viewer ---------- */
  function Viewer(host) {
    // Zdroj modelu se v HTML neuvádí čitelně (data-k = zakódovaný odkaz) a hned se z DOM maže.
    var src = host.getAttribute('data-src') || '';
    var k = host.getAttribute('data-k');
    if (!src && k) { try { src = atob(k).split('').reverse().join(''); } catch (e) { src = ''; } }
    host.removeAttribute('data-k'); host.removeAttribute('data-src');
    host.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    host.addEventListener('dragstart', function (e) { e.preventDefault(); });
    var color = host.getAttribute('data-color') || '#F0F0EA';
    var bg = host.getAttribute('data-bg') || '#F4F4EF';
    var autorotate = host.getAttribute('data-autorotate') !== 'false';
    var upZ = (host.getAttribute('data-up') || 'z') === 'z';

    css(host, {
      position: 'absolute', inset: '0', zIndex: '2', overflow: 'hidden',
      background: 'radial-gradient(circle at 50% 38%, ' + mix(bg, '#ffffff', 0.55) + ' 0%, ' + bg + ' 52%, ' + mix(bg, '#000000', 0.07) + ' 100%)',
      opacity: '0', pointerEvents: 'none', transition: 'opacity .28s ease'
    });

    var stage = el('div', { position: 'absolute', inset: '0' }, host);
    var badge = el('div', {
      position: 'absolute', top: '14px', left: '14px', zIndex: '4',
      font: '600 10px/1 "Space Mono", ui-monospace, monospace', letterSpacing: '.16em', textTransform: 'uppercase',
      color: '#FCFCFA', background: 'rgba(15,15,14,.74)', padding: '7px 11px', borderRadius: '999px', pointerEvents: 'none'
    }, host, '3D model');

    var tools = el('div', {
      position: 'absolute', top: '12px', right: '12px', zIndex: '4',
      display: 'flex', flexDirection: 'column', gap: '8px'
    }, host);
    function toolBtn(glyph, title) {
      var b = el('button', {
        width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center',
        borderRadius: '999px', border: '1px solid #E4E4DC', background: 'rgba(252,252,250,.94)',
        color: '#0F0F0E', font: '400 15px/1 system-ui, sans-serif', cursor: 'pointer', padding: '0',
        boxShadow: '0 2px 8px rgba(15,15,14,.08)', transition: 'background .15s ease, transform .15s ease'
      }, tools, glyph);
      b.type = 'button'; b.title = title; b.setAttribute('aria-label', title);
      b.addEventListener('mouseenter', function () { b.style.background = '#fff'; b.style.transform = 'translateY(-1px)'; });
      b.addEventListener('mouseleave', function () { b.style.background = 'rgba(252,252,250,.94)'; b.style.transform = 'none'; });
      return b;
    }
    var btnReset = toolBtn('⟲', 'Výchozí pohled');
    var btnFull = toolBtn('⤢', 'Na celou obrazovku');

    var hint = el('div', {
      position: 'absolute', left: '50%', bottom: '14px', transform: 'translateX(-50%)', zIndex: '4',
      font: '400 10px/1 "Space Mono", ui-monospace, monospace', letterSpacing: '.12em', textTransform: 'uppercase',
      color: '#5A5A52', background: 'rgba(252,252,250,.88)', padding: '7px 12px', borderRadius: '999px',
      whiteSpace: 'nowrap', pointerEvents: 'none', transition: 'opacity .4s ease'
    }, host, host.getAttribute('data-hint') || 'Táhněte pro otočení · kolečkem přiblížíte');

    var load = el('div', {
      position: 'absolute', inset: '0', zIndex: '5', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: '12px',
      font: '400 10px/1 "Space Mono", ui-monospace, monospace', letterSpacing: '.14em', textTransform: 'uppercase',
      color: '#6E6E66', transition: 'opacity .3s ease'
    }, host);
    var loadTxt = el('div', null, load, 'Načítám 3D model');
    var barWrap = el('div', { width: '108px', height: '2px', background: '#E4E4DC', borderRadius: '2px', overflow: 'hidden' }, load);
    var bar = el('div', { width: '8%', height: '100%', background: '#5CCC78', transition: 'width .2s ease' }, barWrap);

    var api = { host: host, started: false, active: false };
    var T = null, renderer, scene, camera, mesh, raf = null, needs = true, visible = true;
    var sph = { r: 3, t: 0.7, p: 1.15 }, tgt = null, vel = { t: 0, p: 0 }, lastAct = 0, hinted = false;

    function fail(msg) {
      load.style.opacity = '0';
      var e = el('div', {
        position: 'absolute', inset: '0', zIndex: '6', display: 'flex', alignItems: 'center', justifyContent: 'center',
        textAlign: 'center', padding: '0 32px',
        font: '400 10px/1.7 "Space Mono", ui-monospace, monospace', letterSpacing: '.12em', textTransform: 'uppercase', color: '#8A8A80'
      }, host, msg || '3D model se nepodařilo načíst');
      host.setAttribute('data-failed', '1');
      document.querySelectorAll('[data-ml-3d-thumb]').forEach(function (t) { t.style.display = 'none'; });
      return e;
    }

    api.start = function () {
      if (api.started) return;
      api.started = true;
      if (!src) { fail('3D model není nahraný'); return; }
      if (!hasWebGL()) { fail('Prohlížeč nepodporuje 3D náhled'); return; }
      three().then(function (THREE) { return fetchModel(THREE); }).catch(function (err) {
        console.error('[ml-3d] fáze: ' + (err && err.mlPhase || 'neznámá') + ' · ' + (err && err.message), err && err.stack);
        console.warn('[ml-3d] ' + (err && err.message), err);
        var m = String(err && err.message || '');
        if (err && err.mlPhase === 'render') { fail('3D náhled se nepodařilo vykreslit'); return; }
        if (err && err.mlPhase === 'parse') { fail('Soubor není platný STL model'); return; }
        if (m.indexOf('three') > -1 || m.indexOf('Failed to fetch dynamically') > -1) fail('3D knihovnu se nepodařilo načíst');
        else if (m.indexOf('HTTP') > -1) fail('Soubor s modelem se nepodařilo stáhnout (' + m + ') — zkontrolujte odkaz');
        else if (err instanceof TypeError) fail('Soubor s modelem se nepodařilo stáhnout — zkontrolujte odkaz');
        else fail('Soubor není platný STL model');
      });
    };

    function fetchModel(THREE) {
      return fetch(src, { mode: 'cors', credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        var total = +(res.headers.get('content-length') || 0);
        if (!res.body || !total) { bar.style.width = '70%'; return res.arrayBuffer(); }
        var reader = res.body.getReader(), chunks = [], got = 0;
        return (function pump() {
          return reader.read().then(function (r) {
            if (r.done) {
              var out = new Uint8Array(got), at = 0;
              chunks.forEach(function (c) { out.set(c, at); at += c.length; });
              return out.buffer;
            }
            chunks.push(r.value); got += r.value.length;
            bar.style.width = Math.max(8, Math.round(got / total * 100)) + '%';
            return pump();
          });
        })();
      }).then(function (raw) {
        bar.style.width = '100%';
        var buf = unpack(raw);
        var geo;
        try {
          geo = isBinary(buf) ? parseBinary(buf, THREE) : parseASCII(new TextDecoder().decode(buf), THREE);
        } catch (e) { geo = null; }
        // záchrana: když první pokus selže, zkusíme druhý formát
        if (!geo || !geo.getAttribute('position') || geo.getAttribute('position').count < 3) {
          try {
            geo = isBinary(buf) ? parseASCII(new TextDecoder().decode(buf), THREE) : parseBinary(buf, THREE);
          } catch (e2) { geo = null; }
        }
        if (!geo || !geo.getAttribute('position') || geo.getAttribute('position').count < 3) {
          console.error('[ml-3d] soubor nelze p\u0159e\u010d\u00edst jako model \u2014 bajt\u016f: ' + buf.byteLength);
          var pe = new Error('empty geometry'); pe.mlPhase = 'parse'; throw pe;
        }
        try { geo = dropDegenerate(geo, THREE); } catch (e) { console.warn('[ml-3d] čištění přeskočeno', e); }
        try { smooth(geo, THREE, 38); } catch (e) { console.warn('[ml-3d] hladké normály přeskočeny', e); }
        try { build(THREE, geo); } catch (e) { e.mlPhase = 'render'; throw e; }
      });
    }

    function build(THREE, geo) {
      T = THREE;
      renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance', logarithmicDepthBuffer: true, stencil: false });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      if ('outputColorSpace' in renderer && THREE.SRGBColorSpace) renderer.outputColorSpace = THREE.SRGBColorSpace;
      else if ('outputEncoding' in renderer && THREE.sRGBEncoding) renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.toneMapping = THREE.NoToneMapping;
      renderer.shadowMap.enabled = false;
      css(renderer.domElement, { display: 'block', width: '100%', height: '100%', cursor: 'grab', touchAction: matchMedia('(pointer:coarse)').matches ? 'pan-y' : 'none' });
      stage.appendChild(renderer.domElement);

      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(32, 1, 0.1, 4000);

      geo.computeBoundingBox();
      var c = geo.boundingBox.getCenter(new THREE.Vector3());
      geo.translate(-c.x, -c.y, -c.z);
      geo.computeBoundingSphere();
      var R = geo.boundingSphere.radius || 1;
      // near/far musí odpovídat velikosti modelu (mm), jinak vznikají pruhy ze z-fightingu
      camera.near = R * 0.02; camera.far = R * 40; camera.updateProjectionMatrix();

      var mat = new THREE.MeshBasicMaterial({
        color: new THREE.Color(color), side: THREE.FrontSide
      });

      mesh = new THREE.Mesh(geo, mat);
      if (upZ) mesh.rotation.x = -Math.PI / 2;
      scene.add(mesh);

      // obrysy hran — jediná kresba, která zůstává (žádné světlo, žádné odlesky)
      try {
        var eg = new THREE.EdgesGeometry(geo, 26);
        var lines = new THREE.LineSegments(eg, new THREE.LineBasicMaterial({
          color: new THREE.Color(mix(color, '#0F0F0E', 0.42)), transparent: true, opacity: 0.9
        }));
        // obrysy jsou potomkem meshe, takže jeho rotaci dědí — nesmí se otáčet znovu
        mesh.add(lines);
      } catch (e) { console.warn('[ml-3d] obrysy přeskočeny', e); }

      var box = new THREE.Box3().setFromObject(mesh);
      var ctr = box.getCenter(new THREE.Vector3());
      mesh.position.sub(ctr);
      box.setFromObject(mesh);
      tgt = new THREE.Vector3(0, 0, 0);



      sph.r = R / Math.sin((camera.fov * Math.PI / 180) / 2) * 1.05;
      api.home = { r: sph.r, t: 0.72, p: 1.12 };
      sph.t = api.home.t; sph.p = api.home.p;
      api.minR = R * 1.15; api.maxR = R * 5.5;

      resize();
      wire();
      load.style.opacity = '0';
      setTimeout(function () { load.style.display = 'none'; }, 320);
      lastAct = performance.now();
      loop();
    }

    function resize() {
      if (!renderer) return;
      var w = host.clientWidth || 600, h = host.clientHeight || 600;
      renderer.setSize(w, h, false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      needs = true;
    }

    function apply() {
      var p = Math.max(0.16, Math.min(Math.PI - 0.16, sph.p));
      sph.p = p;
      camera.position.set(
        tgt.x + sph.r * Math.sin(p) * Math.sin(sph.t),
        tgt.y + sph.r * Math.cos(p),
        tgt.z + sph.r * Math.sin(p) * Math.cos(sph.t)
      );
      camera.lookAt(tgt);
    }

    function loop() {
      raf = requestAnimationFrame(loop);
      if (!api.active || !visible || document.hidden) return;
      var idle = performance.now() - lastAct > 3200;
      if (Math.abs(vel.t) > 1e-5 || Math.abs(vel.p) > 1e-5) {
        sph.t += vel.t; sph.p += vel.p;
        vel.t *= 0.9; vel.p *= 0.9;
        needs = true;
      }
      if (autorotate && idle) { sph.t += 0.0022; needs = true; }
      if (needs) { apply(); renderer.render(scene, camera); needs = false; }
    }

    function wire() {
      var cv = renderer.domElement, pts = new Map(), last = null, pinch = 0, panning = false;
      function act() {
        lastAct = performance.now();
        if (!hinted) { hinted = true; hint.style.opacity = '0'; }
      }
      cv.addEventListener('pointerdown', function (e) {
        cv.setPointerCapture(e.pointerId);
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        last = { x: e.clientX, y: e.clientY };
        panning = e.shiftKey || e.button === 2 || e.button === 1;
        cv.style.cursor = panning ? 'move' : 'grabbing';
        vel.t = vel.p = 0;
        act();
      });
      cv.addEventListener('pointermove', function (e) {
        if (!pts.has(e.pointerId)) return;
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        act();
        if (pts.size >= 2) {
          var a = Array.from(pts.values());
          var d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
          if (pinch) { sph.r = Math.max(api.minR, Math.min(api.maxR, sph.r * (pinch / d))); needs = true; }
          pinch = d;
          return;
        }
        var dx = e.clientX - last.x, dy = e.clientY - last.y;
        last = { x: e.clientX, y: e.clientY };
        if (panning) {
          var s = sph.r * 0.0016;
          var dir = new T.Vector3();
          camera.getWorldDirection(dir);
          var rt = new T.Vector3().crossVectors(dir, camera.up).normalize();
          var u = new T.Vector3().crossVectors(rt, dir).normalize();
          tgt.addScaledVector(rt, -dx * s).addScaledVector(u, dy * s);
        } else {
          vel.t = -dx * 0.0052; vel.p = -dy * 0.0052;
          sph.t += vel.t; sph.p += vel.p;
        }
        needs = true;
      });
      function up(e) {
        pts.delete(e.pointerId);
        if (pts.size < 2) pinch = 0;
        if (!pts.size) { panning = false; cv.style.cursor = 'grab'; }
      }
      cv.addEventListener('pointerup', up);
      cv.addEventListener('pointercancel', up);
      cv.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      cv.addEventListener('wheel', function (e) {
        e.preventDefault();
        sph.r = Math.max(api.minR, Math.min(api.maxR, sph.r * Math.exp(e.deltaY * 0.0011)));
        needs = true; act();
      }, { passive: false });
      cv.addEventListener('dblclick', reset);
      btnReset.addEventListener('click', reset);
      btnFull.addEventListener('click', function () {
        if (document.fullscreenElement) document.exitFullscreen();
        else if (host.requestFullscreen) host.requestFullscreen();
      });
      document.addEventListener('fullscreenchange', function () {
        var on = document.fullscreenElement === host;
        btnFull.textContent = on ? '⤡' : '⤢';
        cv.style.touchAction = on ? 'none' : (matchMedia('(pointer:coarse)').matches ? 'pan-y' : 'none');
        setTimeout(resize, 60);
      });
      if (window.ResizeObserver) new ResizeObserver(resize).observe(host);
      else window.addEventListener('resize', resize);
    }

    function reset() {
      if (!api.home) return;
      sph.r = api.home.r; sph.t = api.home.t; sph.p = api.home.p;
      tgt.set(0, 0, 0); vel.t = vel.p = 0; needs = true; lastAct = performance.now();
    }

    api.show = function (on) {
      api.active = !!on;
      host.style.opacity = on ? '1' : '0';
      host.style.pointerEvents = on ? 'auto' : 'none';
      if (on) { api.start(); needs = true; setTimeout(resize, 40); }
    };

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { visible = e.isIntersecting; if (visible && host.getAttribute('data-preload') !== 'false') api.start(); });
      }, { rootMargin: '200px' }).observe(host);
    }
    return api;
  }

  /* ---------- napojení na galerii ---------- */
  function markThumb(t) {
    document.querySelectorAll('.ml-pdp__thumb').forEach(function (x) { x.classList.remove('is-on'); });
    if (t) t.classList.add('is-on');
  }
  function init() {
    document.querySelectorAll('[data-ml-3d]').forEach(function (host) {
      if (host.__ml3d) return;
      var v = Viewer(host);
      host.__ml3d = v;
      var thumb = document.querySelector('[data-ml-3d-thumb]');
      if (thumb) {
        // vzhled miniatury nastavujeme z JS (CSS sekce se na živém obchodu může ztratit)
        // miniatura je jen světlá plocha s nápisem 3D — veškerý obsah i pozadí čistíme
        thumb.innerHTML = '';
        css(thumb, {
          position: 'relative', overflow: 'hidden',
          background: '#F4F4EF', backgroundImage: 'none'
        });
        var tag = el('span', null, thumb, '3D');
        tag.className = 'ml-pdp__thumb-tag';
        css(tag, {
          position: 'absolute', inset: '0', zIndex: '2', display: 'flex', alignItems: 'center', justifyContent: 'center',
          font: '700 20px/1 "Space Mono", ui-monospace, monospace', letterSpacing: '.10em', color: '#000000',
          textShadow: 'none'
        });
        thumb.addEventListener('click', function () { v.show(true); markThumb(thumb); });
      }
      document.querySelectorAll('[data-ml-thumb]').forEach(function (t) {
        t.addEventListener('click', function () { v.show(false); });
      });
      if (host.getAttribute('data-active') === 'true') { v.show(true); markThumb(thumb); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.MoldLabs3D = { init: init };
})();
